import i18n from '@/i18n/config';

export class TimeHelper {
    static convertMinuteToText(minute: number) {
        const totalSeconds = minute * 60;
        const totalMinutes = Math.ceil(totalSeconds / 60);

        if (totalMinutes < 60) {
            return i18n.t('common.duration.minute', { count: totalMinutes });
        }

        const hours = Math.floor(totalMinutes / 60);
        const remainingMinutes = totalMinutes % 60;

        if (remainingMinutes === 0) {
            return i18n.t('common.duration.hour', { count: hours });
        }

        return i18n.t('common.duration.hourMinute', { hours, minutes: remainingMinutes });
    }
}
